// extracted by mini-css-extract-plugin
module.exports = {"header":"AutomatSettings_header__1SrcO","generalSettings":"AutomatSettings_generalSettings__1zBAR","loading":"AutomatSettings_loading__1HcCE"};